/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLinks, FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLinksFromJSONTyped, FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLinksToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLinks';
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLinksFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLinksFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLinksFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLinks(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLinksFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLinksToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLinksToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLinksToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLinks(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherLinksToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLinks.js.map